import {appLink, ISellerDetailParams} from "@rw/cars_routes";
import {Dispatch} from "redux";

import {IStore} from "../../app/reducers/hybrid_reducer";
import {IRouteState} from "../../app/routes/data_fetcher/create_app_path_data_fetcher";
import {IServices} from "../../app/services/IServices";
import {carsCommonUrl} from "../../app/utils/read_environment_variables";
import {updateMetaData} from "../../meta_data/actions/update_meta_data";

export const updateSellerMetaData =
    (_services: Partial<IServices>, route: IRouteState<ISellerDetailParams>) => (dispatch: Dispatch, getState: () => IStore) => {
        const seller = getState().seller.data;
        if (!seller) {
            return Promise.resolve(false);
        }

        const count = seller.offers.length;
        const locationBit = seller.city ? ` w mieście ${seller.city}` : "";
        const title = `${seller.name} — oferty samochodów (${count}) | Zakupauto`;
        const description = `Samochody używane od sprzedawcy ${seller.name}${locationBit}. ${count} aktywnych ogłoszeń na Zakupauto.`;
        const url = `${carsCommonUrl}${appLink.seller.detail({slug: seller.slug})}`;
        const robots = count >= 2 ? "index, follow" : "noindex, follow";

        dispatch(updateMetaData(title, description, route, {robots, canonical: url, url}));
        return Promise.resolve(true);
    };
